import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';

export interface ICurrentAndPreviousFlis {
    currentFliIdToAccounts: Map<string, IAccount[]>;
    previousFliIdToAccounts: Map<string, IAccount[]>;
}
